import React, { Fragment, useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import IntlMessages from "../../../../../helpers/IntlMessages";
import AiSentimentsPiChart from "./AiSentimentsPiChart";

const Percentage = ({ data }) => {
  const [percentageData, setPercentageData] = useState([]);
  const [sentimentsData, setSentimentData] = useState([]);
  useEffect(() => {
    const list = [];
    Object.keys(data)
      .filter(
        (per) =>
          per !== "amenties" &&
          per !== "bookings" &&
          per !== "websiteChat" &&
          per !== "facebookChat"
      )
      .forEach((x) => {
        if (x === "trafficAvatarClick") {
          list.push({ label: x, value: data[x], order: 1 });
        }
        if (x === "trafficChatConversion") {
          list.push({ label: x, value: data[x], order: 2 });
        }
        if (x === "understandingAccuracy") {
          list.push({ label: x, value: data[x], order: 3 });
        }
        if (x === "negativeFeedback") {
          list.push({ label: x, value: data[x], order: 4 });
        }
      });
    setPercentageData(list.sort((a, b) => a.order - b.order));
    // console.log(35, data.sentimentData);
    setSentimentData(data.sentimentData);
  }, [data]);

  const getLabel = (lab) => {
    switch (lab.toLowerCase()) {
      case "understandingaccuracy":
        return "dashboards.percentage-accuracy";
      case "trafficchatconversion":
        return "dashboards.percentage-conversion";
      case "amenties":
        return "dashboards.percentage-amenties";
      case "bookings":
        return "dashboards.percentage-booking";
      case "websitechat":
        return "dashboards.percentage-webchats";
      case "facebookchat":
        return "dashboards.percentage-facebookchat";
      case "trafficavatarclick":
        return "dashboards.percentage-avatarclick";
      case "negativefeedback":
        return "dashboards.percentage-negativefeedback";
      default:
        return lab;
    }
  };

  return (
    <Fragment>
      <div className="row">
        {percentageData.map((per, index) => (
          <div className="mb-4 col-lg-3 col-xl-3" key={index}>
            <div className="card">
              <div className="d-flex justify-content-between align-items-center card-body">
                <p>
                  <IntlMessages id={getLabel(per.label)} />
                </p>
                <div
                  className="progress-bar-circle"
                  style={{ width: 60, height: 60 }}
                >
                  <CircularProgressbar
                    strokeWidth={4}
                    value={per.value > 0 ? per.value : 0} // ✅ value instead of percentage
                    maxValue={100}
                    text={per.value > 0 ? `${per.value}%` : "0%"}
                    styles={buildStyles({
                      textSize: "20px",
                      textColor: "#000",
                      pathColor: "#007bff",
                      trailColor: "#d6d6d6",
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {sentimentsData !== undefined && sentimentsData !== null && sentimentsData.length > 0 &&
        <div className="row">
          <div className="mb-4 col-lg-3 col-xl-3">
            <AiSentimentsPiChart
              title={'dashboards.sentiment'}
              subtitle={''}
              labels={['Positive', 'Neutral', 'Negative',]}
              data={sentimentsData} />
          </div>
        </div>
      }

    </Fragment>
  );
};

export default Percentage;
